import { render, staticRenderFns } from "./BaseTransition.vue?vue&type=template&id=54d5bd08&scoped=true&"
import script from "./BaseTransition.vue?vue&type=script&lang=ts&"
export * from "./BaseTransition.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTransition.vue?vue&type=style&index=0&id=54d5bd08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5bd08",
  null
  
)

export default component.exports